import * as theme from "../theme";
// import { FaGem } from "react-icons/fa";
import QuestionText from "./QuestionText";
const SimpleQuestion = ({
  leftString,
  node,
  rightComponent,
  minHeight,
  alignCenter,
  textColor,
  textFamily,
  boldness,
  qTextWidthExlpicit,
  width,
  paddingRightExplicit,
  paddingLeftForQstring,
  paddingRightForQstring,
  error,
  boxlist,
  stylecss
}) => {
  if(stylecss && stylecss.qTextWidthExlpicit){
    qTextWidthExlpicit = stylecss.qTextWidthExlpicit;
  }
  const qTextWidth = qTextWidthExlpicit ? qTextWidthExlpicit : "58%";
  if (boxlist) alignCenter = "No";
  if(stylecss && stylecss.textColor) textColor = stylecss.textColor; 
  const marginTopText = leftString?.length > 200 ? "1.5vh" : null;
  return (
    <div
      style={{
        width: width ? width : "100%",
        minHeight: minHeight ? minHeight : theme.SCALES.simpleQuestionsHeight,
        display: "flex",
        alignItems: alignCenter === "No" ? "" : "center",
        marginTop: marginTopText
      }}
    >
      <div
        className={`_Question `}
        question-id={`${node.id}`}
        question-part={'QuestionSection'}
        style={{
          width: qTextWidth,
          height: "100%",
          display: "flex",
          alignItems: "center",
          // paddingLeft: paddingLeftForQstring
          //   ? paddingLeftForQstring
          //   : theme.SCALES.questionLeftPadding,
          // paddingRight: paddingRightForQstring
          //   ? paddingRightForQstring
          //   : theme.SCALES.questionRightPadding,
          lineHeight: "2.3vmin",
          letterSpacing: "0.15vmin",
          color: textColor
            ? textColor
            : theme.COLORS.group_tab_header_completed,
          fontFamily: textFamily ? textFamily : "GibsonLight",
          fontWeight: boldness ? boldness : "Bold",
          justifyContent: "flex-end",
          textAlign: "left",
        }}
      >
        <QuestionText leftString={leftString} node={node}></QuestionText>
      </div>

      <div
        style={{
          width: `calc(100% - ${qTextWidth})`,
          height: "100%",
          paddingRight: paddingRightExplicit ? paddingRightExplicit : "2vw",
        }}
        question-id={`${node.id}`}
        question-part={'AnswerSection'}
        className={`_QuestionAnswer`}
      >
        {rightComponent}
      </div>
      {error ? (
        <div style={{ color: "red", fontSize: "1.5vmin" }}>{error}</div>
      ) : null}
    </div>
  );
};

export default SimpleQuestion;
